import DataStore from "../DataStore";
import {checkIsCommunitySdk, makeEl} from "../../common/Utils";
import {IJpInfoData, infoType} from "../../interface/IFooter";
import infoTW from "./Info/InfoTW";
import infoJP from "./Info/InfoJP";
import infoRU from "./Info/InfoRU";
import infoCS from "./Info/InfoCS";
import infoNAEU from "./Info/InfoNAEU";
import infoSG_TL from "./Info/InfoSG_TL";
import infoNCV from "./Info/Info_NCV";
import InfoHEROSE_NA from "./Info/InfoHEROSE_NA";
import InfoNCA_bns from "./Info/InfoNCA_bns";
import InfoNCVVN from "./Info/InfoNCVVN";
import InfoNCA_aion from "./Info/InfoNCA_aion";
import InfoNCA_lineage2 from "./Info/InfoNCA_lineage2";

export default class Info{
    private ds : DataStore;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        const infoEl = makeEl('div', _parent, {class: 'footer-info'})
        const csInfoType : infoType = this.ds.config.csInfoType;

        // 코드에서 판별하지 않고 옵션으로 뺐음
        if(this.ds.config.isCsInfoNCVVN){
          new InfoNCVVN(infoEl);
          return;
        }

        // 코드에서 판별하지 않고 옵션으로 뺐음
        if(this.ds.config.isCsInfoNCV){
          new infoNCV(infoEl);
          return;
        }

        if((this.ds.country === 'SG') && (this.ds.service === 'tl')){
          new infoSG_TL(infoEl, csInfoType);  
          return;
        }

        // [TODO] 코드에서 판별하는게 아니라 옵션으로 빼고 싶은데 NCV 처럼
        if((this.ds.country === 'JP') && (this.ds.service !== 'plaync') && (this.ds.service !== 'consent')){
            if(!checkIsCommunitySdk()){
                new infoJP(infoEl);
                return;
            // NCT, NCJ 에서 CommunitySDK 인 경우 어떤 info 도 출력 안함
            }else{
                return;
            }
        }
        
        // [TODO] 코드에서 판별하는게 아니라 옵션으로 빼고 싶은데 NCV 처럼
        if((this.ds.country === 'TW') && (this.ds.service !== 'plaync') && (this.ds.service !== 'consent')){
            if(!checkIsCommunitySdk()){
                new infoTW(infoEl);
                return;
            // NCT, NCJ 에서 CommunitySDK 인 경우 어떤 info 도 출력 안함
            }else{
                return;
            }
        }

        // [TODO] 코드에서 판별하는게 아니라 옵션으로 빼고 싶은데 NCV 처럼
        if(this.ds.service === 'lineage2mru'){
          if(!checkIsCommunitySdk()){
            new infoRU(infoEl);
            return;
            // NR 에서 CommunitySDK 인 경우 어떤 info 도 출력 안함
          }else{
            return;
          }
        }

        // [TODO] 코드에서 판별하는게 아니라 옵션으로 빼고 싶은데 NCV 처럼
        // isCsInfoNCA 옵션도 추가 하고, service로 분기도 태움
        if(
          this.ds.config.isCsInfoNCA || 
          this.ds.service === 'lineage2mnaeu' 
        ){
          if(!checkIsCommunitySdk()){
            new infoNAEU(infoEl);
            return;
            // NR 에서 CommunitySDK 인 경우 어떤 info 도 출력 안함
          }else{
            return;
          }
        }

        // [TODO] 코드에서 판별하는게 아니라 옵션으로 빼고 싶은데 NCV 처럼
        // isCsInfoHEROSE 
        if( this.ds.config.isCsInfoHEROSE){
          if(!checkIsCommunitySdk()){
            new InfoHEROSE_NA(infoEl);
            return;
            // NR 에서 CommunitySDK 인 경우 어떤 info 도 출력 안함
          }else{
            return;
          }
        }

        // [TODO] 코드에서 판별하는게 아니라 옵션으로 빼고 싶은데 NCV 처럼
        // isCsInfoHEROSE 
        if( this.ds.config.isCsInfoNCA_bns){
          if(!checkIsCommunitySdk()){
            new InfoNCA_bns(infoEl);
            return;
            // NR 에서 CommunitySDK 인 경우 어떤 info 도 출력 안함
          }else{
            return;
          }
        }

        // isCsInfoAion
        if( this.ds.config.isCsInfoNCA_aion){
          if(!checkIsCommunitySdk()){
            new InfoNCA_aion(infoEl);
            return;
            // NR 에서 CommunitySDK 인 경우 어떤 info 도 출력 안함
          }else{
            return;
          }
        }

        // isCsInfoLineage2
        if( this.ds.config.isCsInfoNCA_lineage2){
          if(!checkIsCommunitySdk()){
            new InfoNCA_lineage2(infoEl);
            return;
            // NR 에서 CommunitySDK 인 경우 어떤 info 도 출력 안함
          }else{
            return;
          }
        }

        new infoCS(infoEl, csInfoType);
    }
}
